import { getAPIErrorMessage, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { LOGOUT } from '../../app/authState'
import { LOGIN, LOGIN_ERROR, LOGIN_SUCCESS } from './HomeConstants'

const initialState = {
  accessToken: '',
  error: '',
  loading: false,
  defaultServerErrorMessage: '',
}

export default function homeReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case LOGIN:
      return {
        error: '',
        loading: true,
        defaultServerErrorMessage: '',
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case LOGIN_ERROR: {
      let message = ''
      let defaultServerErrorMessage = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, '', action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        message = getAPIErrorMessage(action.payload.ErrorCode)
      }
      return {
        ...state,
        error: message,
        loading: false,
        defaultServerErrorMessage,
      }
    }
    case LOGOUT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
